export const CATEGORIES = [
    "instrument", "audio-effect", "midi-effect", "audio-unit", "audio-effect-chain", "midi-effect-chain"
];
